import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { getToken } from '../utilities/auth/tokenHelpers';

import AvatarEditor from 'react-avatar-editor'


import Header from '../utilities/header';
import OrganizationCard from '../utilities/organizationCard';
import Footer from '../utilities/footer';


function OrganizationImageScreen() {


  // Define variables
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [orgId, setOrgId] = useState('');
  const [previewUrl, setPreviewUrl] = useState(null);
  const [scale, setScale] = useState(1);
  const profileData = useSelector((state) => state.profile);
  const firstName = profileData.firstName;
  const organizations = profileData.organizations || [];
  const orgIds = organizations.map((org) => org.id);
  const hasOrgAccess = orgIds.includes(64);
  const hasAccess = (firstName === 'John' || firstName === 'Matt') && hasOrgAccess;


  // Component load actions
  useEffect(() => {

    // Ensure it's Matt or John
    if( profileData.initalized ) {
      if( !hasAccess ) {
        navigate('/');
      }
    }
  }, [profileData.initalized]);


  // Define functions
  function handleUpload(event) {
    const file = event.target.files[0];
    const preview = URL.createObjectURL(file);

    setPreviewUrl(preview);
  }

  function handleScale(value) {
    let newScale;

    if( value > 0 ) {
      newScale = 1 + (value / 10);
    } else {

      newScale = 1 + (value / 35);
    }

    setScale(newScale);
  }

  async function handleSave() {

    if( !orgId ) {
      alert('Please enter an Organization ID');
      return;
    }

    if( editorRef ) {
      setUploading(true);

      const dataUrl = editorRef.current.getImage().toDataURL();
      const res = await fetch(dataUrl);
      const blob = await res.blob();

      const formData = new FormData();
      formData.append(`organization[logo]`, blob, 'logo');

      const config = {
        method: 'post',
        url: `/org_admin/${orgId}/upload_logo`,
        headers: { authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
        data : formData
      };


      // Send the data to the server
      return axios(config).then(function (response) {
        const data = response.data;

        if( data.success ) {
          alert('Logo uploaded successfully');

          setScale(1);
          setOrgId('');
          setPreviewUrl(null);
        } else {
          alert(data.error);
        }

      }).catch(function (error) {
        alert(error);
      }).finally(() => {
        setUploading(false);
      });

    }
  }


  // Screen componets
  let previewElement;
  if( previewUrl ) {
    previewElement = (
      <div>
        <div class='organization-logo-preview-container'>

        <div class='flex-row' style={{alignItems: 'flex-start', width: '795px'}}>
          <p>Click and drag to crop the image</p>

          <div>
            <p>Drag to scale image</p>
            <input type="range" min="-30" max="10" defaultValue={scale} onChange={(event) => handleScale(event.target.value)} />
          </div>
        </div>
          <AvatarEditor
            ref={editorRef}
            image={previewUrl}
            width={675}
            height={250}
            border={60}
            color={[255, 255, 255, 0.6]} // RGBA
            scale={scale}
            rotate={0}
          />
        </div>

        <button
          class='button primary'
          onClick={() => handleSave()}
          disabled={uploading}
        >Save</button>
      </div>
    );
  }


  return(
    <div class='flex-column'>

      <Header />
      <OrganizationCard />

      <div class='body-container'>

        <h2>Upload Logo for an Organization</h2>
        <br />
        <p><i>Don't worry about the Organization name above, you can upload a logo for any Organization.</i></p>

        <div style={{marginTop: '60px'}}>

          <label>Organization ID</label>
          <input type='number' value={orgId} onChange={(event) => setOrgId(event.target.value)} />

          <br />
          <br />
          <label>Image ( 675px x 250px )</label>
          <input type='file' onChange={(event) => handleUpload(event) } />
          {previewElement}
        </div>

      </div>

      <Footer />

    </div>
  );
}

export default OrganizationImageScreen;